import * as React from "react";
const AddToWalletApple = (props) => (
    <svg
        width={143}
        height={38}
        viewBox="0 0 143 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <rect width={143} height={38} rx={19} fill="#23262f" />
        <mask
            id="a"
            style={{
                maskType: "luminance",
            }}
            maskUnits="userSpaceOnUse"
            x={15}
            y={12}
            width={19}
            height={14}
        >
            <path
                d="M33.668 23.392v.193l-.001.276q0 .117-.004.234c-.004.169-.014.34-.044.507-.03.17-.08.328-.159.482q-.117.228-.299.41a1.64 1.64 0 0 1-.892.457c-.167.03-.338.04-.507.045q-.117.003-.233.003l-.276.001h-1.06.986-13.69.986-1.336l-.234-.004a3.4 3.4 0 0 1-.507-.045c-.17-.03-.327-.08-.482-.159a1.64 1.64 0 0 1-.868-1.19 3.4 3.4 0 0 1-.044-.507l-.003-.233-.001-.277v-9.019.908-1.336l.004-.233c.005-.17.015-.34.045-.507.03-.17.08-.328.159-.482a1.6 1.6 0 0 1 .71-.708c.153-.079.311-.129.481-.16.167-.03.338-.04.507-.044l.233-.003.277-.001h14.113l.233.004c.17.005.34.015.507.045.17.03.328.08.482.159q.229.117.41.298a1.64 1.64 0 0 1 .458.893c.03.167.04.337.044.506a12 12 0 0 1 .005.51z"
                fill="#fff"
            />
        </mask>
        <g mask="url(#a)">
            <path d="M33.077 12.584h-17.5v12.185h17.5z" fill="#dedbce" />
            <path d="M32.89 12.78H15.778v7.259H32.89z" fill="#40a5d9" />
            <g filter="url(#b)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M32.89 15.867v-.176q0-.075-.003-.148a2 2 0 0 0-.028-.322 1.1 1.1 0 0 0-.101-.305 1 1 0 0 0-.45-.45 1.1 1.1 0 0 0-.306-.101 2 2 0 0 0-.322-.029l-.148-.002H17.135q-.075 0-.148.002-.163.003-.322.028-.16.028-.305.101a1 1 0 0 0-.45.45 1.1 1.1 0 0 0-.102.306 2 2 0 0 0-.028.322l-.002.148v.847-.527 5.583h17.111z"
                    fill="#ffb003"
                />
            </g>
            <g filter="url(#c)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M32.89 17.422v-.176q0-.075-.003-.148a2 2 0 0 0-.028-.322 1.1 1.1 0 0 0-.101-.306 1 1 0 0 0-.45-.45 1.1 1.1 0 0 0-.306-.1 2 2 0 0 0-.322-.03l-.148-.001H17.135q-.075 0-.148.002-.163.003-.322.028-.16.028-.305.101a1 1 0 0 0-.45.45q-.074.146-.102.306a2 2 0 0 0-.028.322l-.002.148v.847-.528 5.584h17.111z"
                    fill="#40c740"
                />
            </g>
            <g filter="url(#d)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M32.89 18.976v-.175q0-.075-.003-.149a2 2 0 0 0-.028-.321 1.1 1.1 0 0 0-.101-.306 1 1 0 0 0-.45-.45 1.1 1.1 0 0 0-.306-.101 2 2 0 0 0-.322-.029l-.148-.002H17.135l-.148.002c-.108.003-.216.01-.322.029s-.207.05-.305.1a1 1 0 0 0-.45.451q-.074.145-.102.306a2 2 0 0 0-.028.321l-.002.148v.848-.528 5.583h17.111z"
                    fill="#f26d5f"
                />
            </g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.742 11.74v8.037h1.037v-5.643q0-.075.002-.149.003-.161.028-.321a1.1 1.1 0 0 1 .101-.306 1 1 0 0 1 .45-.45q.146-.072.305-.1.16-.025.322-.028l.148-.002h14.399q.075 0 .148.002.162.003.322.028.16.028.305.101a1 1 0 0 1 .45.45q.074.147.101.306c.02.106.026.214.029.322l.002.148v5.644h1.037V11.74z"
                fill="#d9d6cc"
            />
            <g filter="url(#e)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M29.107 19h-.334l-.28.005a4 4 0 0 0-.613.054 2 2 0 0 0-.581.191c-.024.013-.536.245-.997.961-.349.544-1.029 1.12-1.98 1.12s-1.631-.576-1.982-1.12c-.484-.754-1.036-.98-.997-.96a2 2 0 0 0-.581-.192 4 4 0 0 0-.612-.054l-.281-.004-.334-.001h-4.793v7.26h19.186V19z"
                    fill="#dedbce"
                />
            </g>
        </g>
        <path
            d="M41.413 15H40.25l2.617-7.273h1.267L46.752 15h-1.165L43.53 9.048h-.057zm.196-2.848h3.778v.923H41.61zm8.06 2.955q-.66 0-1.178-.338a2.3 2.3 0 0 1-.81-.97q-.291-.63-.291-1.516 0-.884.295-1.512.297-.63.816-.963a2.1 2.1 0 0 1 1.176-.334q.507 0 .817.17.312.168.483.392.174.223.27.394h.063V7.727h1.062V15h-1.037v-.849h-.089a3 3 0 0 1-.277.398q-.177.225-.49.39-.312.168-.81.168m.235-.906q.458 0 .774-.242.32-.245.483-.678.167-.433.167-1.008 0-.569-.163-.995a1.46 1.46 0 0 0-.48-.664q-.315-.237-.78-.238-.48 0-.8.249a1.5 1.5 0 0 0-.483.678q-.16.43-.16.97 0 .546.164.983t.483.693q.323.252.795.252m6.025.906q-.66 0-1.178-.338a2.3 2.3 0 0 1-.81-.97q-.291-.63-.291-1.516 0-.884.294-1.512.299-.63.817-.963a2.1 2.1 0 0 1 1.176-.334q.507 0 .816.17.313.168.483.392.174.223.27.394h.064V7.727h1.062V15h-1.037v-.849h-.089a3 3 0 0 1-.277.398q-.178.225-.49.39-.312.168-.81.168m.235-.906q.458 0 .774-.242.32-.245.483-.678.167-.433.167-1.008 0-.569-.163-.995a1.46 1.46 0 0 0-.48-.664q-.315-.237-.781-.238-.48 0-.8.249a1.5 1.5 0 0 0-.482.678q-.16.43-.16.97 0 .546.163.983.164.437.483.693.324.252.796.252m9.176-4.656v.853h-2.98v-.853zM63.16 8.24h1.061v5.16q0 .307.093.465.091.152.238.21.15.052.323.052.128 0 .224-.017l.149-.029.191.877a2.1 2.1 0 0 1-.689.114 1.9 1.9 0 0 1-.78-.15 1.34 1.34 0 0 1-.587-.482q-.223-.327-.223-.82zm5.594 6.871q-.767 0-1.34-.351a2.37 2.37 0 0 1-.887-.984q-.316-.632-.316-1.477 0-.849.316-1.485t.888-.987q.57-.352 1.339-.352.766 0 1.338.352.572.351.888.987t.316 1.485q0 .845-.316 1.477a2.37 2.37 0 0 1-.888.983q-.57.352-1.338.352m.003-.891q.497 0 .824-.263a1.54 1.54 0 0 0 .483-.7q.16-.436.16-.962a2.8 2.8 0 0 0-.16-.959 1.56 1.56 0 0 0-.483-.706q-.327-.267-.824-.267-.5 0-.83.267-.328.266-.487.706a2.8 2.8 0 0 0-.157.959q0 .525.157.962.159.438.486.7.33.263.831.263M41.837 30h-1.514l3.402-9.454h1.649L48.776 30h-1.514l-2.673-7.737h-.074zm.254-3.702h4.912v1.2h-4.912zm7.94 6.361v-9.75h1.348v1.15h.115q.12-.222.346-.513.226-.29.628-.508.402-.22 1.062-.221a2.77 2.77 0 0 1 1.532.434q.675.434 1.058 1.25.387.819.387 1.967 0 1.15-.383 1.972-.383.816-1.052 1.26a2.73 2.73 0 0 1-1.528.439q-.647 0-1.058-.217a2 2 0 0 1-.637-.508 4 4 0 0 1-.355-.517h-.083v3.762zm1.352-6.204q0 .747.217 1.31t.628.882q.411.315 1.006.314.619 0 1.034-.327.416-.333.628-.9a3.6 3.6 0 0 0 .217-1.28q0-.7-.212-1.26a1.93 1.93 0 0 0-.628-.881q-.415-.324-1.039-.324-.6 0-1.015.31a1.9 1.9 0 0 0-.624.863q-.212.554-.212 1.293m6.67 6.204v-9.75h1.349v1.15h.115q.12-.222.346-.513.226-.29.628-.508.402-.22 1.062-.221a2.77 2.77 0 0 1 1.533.434q.675.434 1.057 1.25.387.819.388 1.967 0 1.15-.383 1.972-.384.816-1.053 1.26a2.73 2.73 0 0 1-1.528.439q-.645 0-1.057-.217a2 2 0 0 1-.637-.508 4 4 0 0 1-.356-.517h-.083v3.762zm1.354-6.204q0 .747.217 1.31.216.564.627.882.411.315 1.007.314.618 0 1.034-.327.415-.333.628-.9.217-.57.217-1.28 0-.7-.213-1.26a1.93 1.93 0 0 0-.628-.881q-.416-.324-1.038-.324-.6 0-1.016.31a1.9 1.9 0 0 0-.623.863q-.213.554-.212 1.293m8.05-5.91V30h-1.38v-9.454zm4.914 9.598q-1.048 0-1.805-.448a3.04 3.04 0 0 1-1.164-1.27q-.405-.821-.406-1.924 0-1.09.406-1.92a3.16 3.16 0 0 1 1.145-1.298q.739-.465 1.727-.466.6 0 1.163.198.564.199 1.011.624.448.424.707 1.103.258.674.258 1.639v.489h-5.637v-1.034h4.284q0-.545-.221-.965a1.7 1.7 0 0 0-.623-.67 1.74 1.74 0 0 0-.933-.244q-.582 0-1.016.286a1.9 1.9 0 0 0-.664.739q-.231.453-.231.983v.808q0 .71.25 1.21.253.498.705.761.453.26 1.058.259.392 0 .715-.111.324-.115.559-.342.235-.226.36-.558l1.306.235a2.4 2.4 0 0 1-.563 1.011q-.402.43-1.01.67a3.8 3.8 0 0 1-1.381.235M82.347 30l-2.622-9.454h1.5l1.842 7.321h.088l1.916-7.321h1.486l1.916 7.326h.088l1.837-7.326h1.505L89.276 30h-1.435l-1.99-7.082h-.074L83.787 30zm12.111.157q-.674 0-1.218-.25a2.05 2.05 0 0 1-.864-.733q-.314-.48-.314-1.178 0-.6.231-.987.231-.389.623-.614.393-.227.877-.342.486-.116.988-.175l1.034-.12q.397-.051.578-.162t.18-.36v-.033q0-.604-.342-.937-.337-.332-1.006-.332-.697 0-1.1.31-.396.304-.549.678l-1.297-.296q.231-.645.674-1.043a2.7 2.7 0 0 1 1.03-.582 4 4 0 0 1 1.223-.184q.424 0 .9.101.48.098.896.36.42.264.688.753.267.485.268 1.26V30H96.61v-.97h-.056q-.134.268-.401.527a2.1 2.1 0 0 1-.688.43q-.42.17-1.007.17m.3-1.108q.573 0 .979-.226.411-.227.623-.591.217-.37.217-.79v-.914q-.073.075-.286.139a5 5 0 0 1-.475.106l-.522.079-.425.055a3.4 3.4 0 0 0-.734.17 1.26 1.26 0 0 0-.526.347q-.195.222-.194.59 0 .514.378.777.38.258.965.258m6.418-8.503V30h-1.38v-9.454zm3.238 0V30h-1.381v-9.454zm4.913 9.597q-1.049 0-1.805-.448a3.04 3.04 0 0 1-1.164-1.27q-.406-.821-.406-1.924 0-1.09.406-1.92a3.16 3.16 0 0 1 1.145-1.298q.739-.465 1.727-.466.6 0 1.163.198.564.199 1.011.624.448.424.707 1.103.258.674.258 1.639v.489h-5.637v-1.034h4.284q0-.545-.221-.965a1.7 1.7 0 0 0-.623-.67 1.74 1.74 0 0 0-.933-.244q-.582 0-1.016.286a1.9 1.9 0 0 0-.664.739 2.1 2.1 0 0 0-.231.983v.808q0 .71.249 1.21.254.498.706.761.452.26 1.058.259.392 0 .715-.111.324-.115.559-.342.235-.226.36-.558l1.306.235a2.36 2.36 0 0 1-.563 1.011q-.402.43-1.011.67a3.8 3.8 0 0 1-1.38.235m7.884-7.234v1.108h-3.874v-1.108zm-2.835-1.699h1.38v6.708q0 .402.12.605.12.198.31.272.194.07.42.07.167 0 .291-.024.124-.022.194-.037l.249 1.14q-.12.047-.342.093a2.7 2.7 0 0 1-.554.055 2.4 2.4 0 0 1-1.015-.194 1.74 1.74 0 0 1-.762-.627q-.291-.425-.291-1.067z"
            fill="#fff"
        />
        <defs>
            <filter
                id="b"
                x={12.778}
                y={11.134}
                width={23.111}
                height={13.26}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy={-0.2} />
                <feGaussianBlur stdDeviation={1.5} />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
                <feBlend
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_4477_48482"
                />
                <feBlend
                    in="SourceGraphic"
                    in2="effect1_dropShadow_4477_48482"
                    result="shape"
                />
            </filter>
            <filter
                id="c"
                x={12.778}
                y={12.689}
                width={23.111}
                height={13.26}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy={-0.2} />
                <feGaussianBlur stdDeviation={1.5} />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
                <feBlend
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_4477_48482"
                />
                <feBlend
                    in="SourceGraphic"
                    in2="effect1_dropShadow_4477_48482"
                    result="shape"
                />
            </filter>
            <filter
                id="d"
                x={12.778}
                y={14.243}
                width={23.111}
                height={13.26}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy={-0.2} />
                <feGaussianBlur stdDeviation={1.5} />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
                <feBlend
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_4477_48482"
                />
                <feBlend
                    in="SourceGraphic"
                    in2="effect1_dropShadow_4477_48482"
                    result="shape"
                />
            </filter>
            <filter
                id="e"
                x={11.742}
                y={15.8}
                width={25.186}
                height={13.26}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy={-0.2} />
                <feGaussianBlur stdDeviation={1.5} />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
                <feBlend
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_4477_48482"
                />
                <feBlend
                    in="SourceGraphic"
                    in2="effect1_dropShadow_4477_48482"
                    result="shape"
                />
            </filter>
        </defs>
    </svg>
);
export default AddToWalletApple;
